import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OtpService } from '../services/otp.service';
import { TimerUtils } from '../utils/timer-utils';
import { BaseService } from '../services/base.service';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OTPComponent implements OnInit {

  private timerUtils: TimerUtils;

  // Timer
  secondLeft: number;
  minLeft: number;

  sendOTPType = new FormControl('2', Validators.required);

  otpNum = new FormControl(null, [Validators.required, Validators.pattern('^[\\d]{0,15}$')]);

  show: boolean;

  /** 取得經遮罩之使用者OTP聯絡資訊 */
  info$: Observable<any> = this.otpService.getMaskedContactInfo().pipe(map(res => res.payload.body));

  constructor(
    private otpService: OtpService,
    private router: Router,
    private route: ActivatedRoute,
    private baseService: BaseService
  ) {
  }

  ngOnInit(): void {
    // this.baseService.detectBrowserRefresh();
    this.timerUtils = TimerUtils.getInstance();
  }

  /*
  * 使用者選擇OTP驗證方式後，傳遞給後端進行發送
  * */
  sendOTP() {
    if (this.sendOTPType.invalid) {
      alert('請先選擇密碼驗證方式並進行身分驗證');
      return;
    }
    this.otpService.sendOtp(this.sendOTPType.value).subscribe(() => {
      alert('驗證碼已送出');
      // Disable button and timer on
      this.show = true;
      this.componentTimerOn(5);
    });
  }

  /*
  * 使用者輸入的OTP碼進行驗證
  * */
  validateOTP() {
    // Prevent Injection Attack
    if (this.otpNum.invalid) {
      alert('請輸入驗證碼');
      return;
    }
    this.otpService.validateOTP(this.otpNum.value).subscribe(res => {
      // FIXME 應該是不用再alert
      if (!res.succeeded) {
        this.otpNum.reset();
        switch (res.code) {
          case 'failed':
            alert('驗證碼錯誤');
            break;
          case 'timeOut':
            this.setTimeout();
            this.show = false;
            break;
          case 'logout':
            // TODO 登出
            break;
          default:
            console.log(res.code + res.message);
            alert(res.message);
            break;
        }
        return;
      };
      this.timerUtils.cancelComponentTimer();
      alert('驗證成功');
      this.next();
    })
  }

  /* UI trigger */
  private componentTimerOn(minutes: number) {
    this.timerUtils.startComponentTimer(minutes * 60, second => {
      if (second > 0) {
        this.secondLeft = second % 60;
        this.minLeft = Math.floor(second / 60);
      } else {
        this.secondLeft = 0;
        this.setTimeout();
      }
    });
  }

  private setTimeout() {
    // TODO: 設置逾時處理
    this.timerUtils.cancelComponentTimer();
    this.show = false;
    this.otpNum.reset();
    this.sendOTPType.reset('2');
    alert('驗證碼逾時，請重新驗證');
  }

  /* Pagination */
  prev() {
    this.baseService.info.browserRefresh = false;
    this.router.navigate(['../step2'], { relativeTo: this.route });
  }

  next() {
    this.baseService.info.browserRefresh = false;
    this.router.navigate(['../step4'], { relativeTo: this.route });
  }

}
